// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3xOhe","rootSmall":"AddTileButton_rootSmall__3AgwM"};